import { datadogRum } from "@datadog/browser-rum";

// Datadog RUM prohibits these characters in feature flag names.
// https://docs.datadoghq.com/real_user_monitoring/feature_flag_tracking/setup/?tab=browser#custom-feature-flag-management
const PROHIBITED_CHARS = /[.:+\-=&|><!(){}[\]^"~*?\\]/g;

export const sanitizeKey = (key: string) => key.replace(PROHIBITED_CHARS, "_");

/**
 * Reports a feature flag evaluation to Datadog RUM so sessions, errors, and actions
 * can be correlated with which flags were active. Safe to call on every evaluation;
 * the Browser RUM SDK deduplicates by key within a view.
 */
export const trackFeatureFlagEvaluation = (key: string, value: boolean | string | number) => {
  try {
    datadogRum.addFeatureFlagEvaluation(sanitizeKey(key), value);
  } catch {
    // Datadog RUM may not be initialized (e.g. in tests, SSR, or when the client
    // token isn't configured). Tracking must never break feature flag logic.
  }
};
